// extracted by mini-css-extract-plugin
module.exports = {"_subInfo":"DokumentSilageergebnisse__subInfo__3ymc7","_checkbox":"DokumentSilageergebnisse__checkbox__8E1Js"};